export default ["LocaleService",function i18n(LocaleService) {
  return function (input, args) {
    let re = /<[^>]*>/gi;
    return LocaleService.getString(input, args).replace(re, " ");
  };
}];



// WEBPACK FOOTER //
// ./src/ui/app/filter/i18nNoBrFilter.js